<script>
  import appConfig from '@/app.config';
  import TvSocial from '@/components/TvSocial.vue';
  import FooterLanguage from '@/components/FooterLanguage.vue';
  import FooterNav from '@/components/FooterNav.vue';
  import Social from '@/components/social.vue';
  import { gsap } from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';

  export default {
    props: {
      showLoadingScreen: {
        type: Boolean,
      },
    },
    components: { TvSocial, FooterLanguage, FooterNav, Social },
    data: () => ({
      assetsPath: appConfig.assetsPath,
      //return{
      showBg: false,
      bgStyle: {
        // backgroundColor: "transparent",
      },
      myStyle: {
        marginTop: 0,
      },
      footerScrollStyle: {
        height: '300px',
      },
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1], // [0.25, 0.75] if you want a 25% offset!
      },
      viewPoint: '',
      currentScroll: 0,
      //}
    }),

    mounted() {
      const clientHeight = this.$refs.footer.clientHeight;
      this.footerScrollStyle.height = clientHeight + 'px';
    },
    watch: {
      showLoadingScreen(newVal, oldVal) {
        // console.log(newVal, '>', oldVal)
        if (!newVal && oldVal) {
          console.log(' wath it >>> ');
          this.gspLoad();
        }
      },
    },
    methods: {
      gspLoad() {
        console.log(' footer animtion  >>>> ');
        // *** Animation  ***
        const clientHeight = this.$refs.footer.clientHeight;
        const isMobile = window.innerWidth < 768;
        let bgColorDelay = '1.6';
        if (isMobile) {
          bgColorDelay = '2.1';
        }
        gsap.registerPlugin(ScrollTrigger);
        gsap.defaults({ duration: 2 });
        const tl = gsap.timeline();

        tl
          //.to(".footer", {duration: 2, y: -500, delay: 2})
          // .to("#parent-main-block", {top: 100, delay: 1.5})
          .to('#footerBg', { display: 'block', opacity: 1, delay: 1.5 })
          .to('#parent-main-block', { webkitFilter: 'blur(10px)' });

        ScrollTrigger.create({
          animation: tl,
          trigger: '.footerScrollStyle',
          start: '0 90%',
          end: '+=' + clientHeight + '',
          scrub: 0.8,
          // markers: true,
          //triggerActions: " restart pause reverse pause"
          //stagger: .2 // for childs delay
        });

        const footerT2 = gsap.timeline();
        footerT2.to('#helpSupport_animate', { y: 200 });
        ScrollTrigger.create({
          animation: footerT2,
          trigger: '.footerScrollStyle',
          start: '0 90%',
          end: '+=' + clientHeight + '',
          scrub: 0.8,
          // markers: true,
          //triggerActions: " restart pause reverse pause"
          //stagger: .2 // for childs delay
        });

        const showMoreElemnent = document.getElementById('showMore');
        if (showMoreElemnent) {
          showMoreElemnent.addEventListener('click', () => {
            tl.clear(true);
            footerT2.clear(true);

            setTimeout(() => {
              tl.to('#footerBg', { display: 'block', opacity: 1, delay: 1.5 }).to(
                '#parent-main-block',
                { webkitFilter: 'blur(10px)' },
              );
              ScrollTrigger.create({
                animation: tl,
                trigger: '.footerScrollStyle',
                start: '0 90%',
                end: '+=' + clientHeight + '',
                scrub: 0.8,
                // markers: true,
              });
              footerT2.to('#helpSupport_animate', { y: 200 });
              ScrollTrigger.create({
                animation: footerT2,
                trigger: '.footerScrollStyle',
                start: '0 90%',
                end: '+=' + clientHeight + '',
                scrub: 0.8,
                // markers: true,
                //triggerActions: " restart pause reverse pause"
                //stagger: .2 // for childs delay
              });
            }, 1000);
            ScrollTrigger.refresh(true);
          });
        }
      },
      onWaypoint({ going, direction }) {
        // going: in, out
        // direction: top, right, bottom, left
        if (going === this.$waypointMap.GOING_IN) {
          //console.log('waypoint going in!', window.scrollY)
          if (this.viewPoint !== 'in') {
            this.viewPoint = 'in';
            this.currentScroll = window.scrollY;
          }
        }

        if (going === this.$waypointMap.GOING_OUT) {
          this.viewPoint = 'out';
          this.showBg = false;
          this.myStyle.marginTop = 0;
        }

        if (direction === this.$waypointMap.DIRECTION_TOP) {
          //console.log('waypoint going top!')
        }
      },
      // onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      //   // //console.log('scro>', scrollTop)
      //   // if (scrollTop === 0) {
      //   //   this.hideModal();
      //   // }
      //   // const num = 0 + scrollTop / (clientHeight - 300);
      //   // this.myStyle.backgroundColor = 'rgba(35, 44, 83, '+ num +' )';
      //   // if (scrollTop + clientHeight >= scrollHeight) {
      //   //   //this.loadMorePosts()
      //   // }
      // }
    },
  };
</script>

<template>
  <div>
    <div
      v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
      ref="infoBox"
    >
      <div
        :class="$style.footerScroll"
        class="d-inline-block w-100 footerScrollStyle"
        :style="footerScrollStyle"
      >
        <div
          :class="$style.footerBg"
          :style="bgStyle"
          id="footerBg"
        />
        <div
          :class="$style.footer"
          :style="myStyle"
          class="d-inline-block w-100 footer"
          ref="footer"
        >
          <div
            class="overflow-hidden"
            :class="$style.footerTopPhoto"
          >
            <!-- <img src="@/assets/images/footer-banner.svg" alt="" class="w-100" /> -->
          </div>
          <div
            :class="$style.footerContent"
            class="d-inline-block w-100"
          >
            <b-container>
              <div class="w-100 d-inline-block">
                <b-row>
                  <b-col
                    lg="4"
                    md="4"
                    sm="12"
                  >
                    <div
                      class="pr-lg-5"
                      :class="$style.gap"
                    >
                      <TvSocial customClass="d-none" />
                    </div>
                  </b-col>
                  <b-col
                    lg="4"
                    md="4"
                    sm="12"
                  >
                    <FooterNav />
                  </b-col>
                  <b-col
                    lg="4"
                    md="4"
                    sm="12"
                  >
                    <div class="d-none d-md-inline-block d-lg-inline-block d-xl-inline-block w-100">
                      <FooterLanguage />
                    </div>
                    <Social class="d-lg-none d-md-none d-xl-none w-100 mt-0" />
                    <div :class="$style.aboutBlock">
                      <p>重庆创浪时代未来科技有限公司</p>
                      <p v-if="GLOBAL.domainJudge() !== 'aws'">
                        <a
                          href="https://beian.miit.gov.cn/"
                          target="_blank"
                          >渝ICP备2023006780号</a
                        >
                      </p>
                      <!-- <ul>
                        <li><a :href="GLOBAL.hrefLink('privacy')">{{ $t("footer.privacy") }} </a></li>
                        <li><span :class="$style.separator"></span></li>
                        <li><a href="#">{{ $t("footer.text") }}</a></li>
                      </ul> -->
                    </div>
                    <!-- <div class="w-100 d-inline-block">
                      <a
                        href="https://www.kidsafeseal.com/certifiedproducts/drpanda_appseries.html"
                        target="_blank"
                        ><img
                          border="0"
                          alt="Dr. Panda's library of apps is certified by the kidSAFE Seal Program."
                          src="https://www.kidsafeseal.com/sealimage/1643740561778540647/drpanda_appseries_large_whitetm.png"
                      /></a>
                    </div> -->
                  </b-col>
                </b-row>
              </div>
              <div :class="$style.markFooter">
                <img
                  src="https://preview-web.xiongmaoboshi.com/resource/assets/images/gatp.png"
                  width="16"
                  height="16"
                  alt=""
                />
                &nbsp; &nbsp;
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=50010802006234"
                  rel="noreferrer"
                  target="_blank"
                  >渝公网安备50010802006234号</a
                >
              </div>
            </b-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss"></style>
<style lang="scss" module>
  @import '@/design/_colors.scss';
  @import '@/design/_fonts.scss';
  .footerScroll {
  }
  .footerBg {
    display: none;
    background-color: rgba(35, 44, 83, 1);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    opacity: 0;
  }
  .footer {
    // position: fixed;
    left: 0;
    right: 0;
    // transform: translateY(100%);

    //background-color: rgba(35, 44, 83, 1);
    .footerContent {
      background-color: $footer-bg;
      margin-top: -2px;
      padding-bottom: 120px;
      padding-top: 120px;
      position: relative;
    }
    .footerTopPhoto {
      height: 200px;
      position: relative;
      background-image: url('#{$assetsPath}images/footer-banner.svg');
      background-repeat: no-repeat;
      background-position: center 0;
      background-size: cover;
    }
    .aboutBlock {
      margin-top: 40px;
      p {
        color: #8792c9;
        font-size: 16px;
        a {
          color: #8792c9;
          font-size: 16px;
        }
      }
      ul {
        padding: 0;
        width: 100%;
        display: inline-block;
        li {
          list-style: none;
          float: left;
          a {
            color: #8792c9;
            font-size: 16px;
          }
        }
        .separator {
          border-left: 2px solid #8792c9;
          margin: 0 10px;
        }
      }
    }
  }
  .gap {
    padding-bottom: 0px;
  }
  .permiticon {
    img {
      width: 110px;
      :hover {
        transform: scale(1.1);
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .gap {
      padding-bottom: 40px;
    }
    .footer {
      .footerContent {
        padding-bottom: 80px;
        padding-top: 0;
        margin-top: -72px;
      }
      .aboutBlock {
        p {
          font-size: 14px;
        }
        ul {
          li {
            a {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .markFooter {
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      color: #8792c9;
      font-size: 16px;
    }
  }
</style>
